import { Row, Col, Dialog, ButtonGroup, ButtonIcon, DialogCardClose, Icon, Tab, TabList, DialogCardHead, DialogCardHeadTitle, Typography } from "@visa/vds"
import React, { useState } from "react"
import MCSOverlayLoading from "components/MCSOverlayLoading";
import { gettingStartedService } from "services/certification.gettingStarted";
import { GETTING_STARTED_FOOTNOTES, IMPLEMENTATION_TYPE_PRODUCTS, QUESTIONS_ANSWERS_3DS, QUESTIONS_ANSWERS_ACS, TABLE_HEADERS_3DS, TABLE_HEADERS_ACS } from "_constants/CertificationTestingConstants";
import Tooltip from "rc-tooltip/lib/Tooltip";
import Questionnaire from "./Questionnaire";
import iconACSGray from "_imgs/gettingStarted/icon-acs-gray.png"
import icon3DSSGray from "_imgs/gettingStarted/icon-3dss-gray.png"
import iconACS from "_imgs/gettingStarted/icon-acs.png"
import icon3DSS from "_imgs/gettingStarted/icon-3dss.png"

export const renderFootnote = (footnote) => {
    return <>
        {renderFootnoteText(footnote)}
        <br />
        {
            footnote.links.map((item, id) => {
                if (!item.inline) return <>
                    {renderFootnoteLink(item, id)}
                    <br />
                </>
            })
        }
    </>
}

const renderFootnoteText = (footnote) => {
    let text = footnote.label;
    let inlineLinks = footnote.links.filter(item => item.inline);

    if (inlineLinks.length === 0) return text;

    // assume that inline links are in order of appearance
    const splitText = text.split(new RegExp(inlineLinks.map(item => item.label).join('|'), 'g'));

    return splitText.map((text, i) => {
        if (i < splitText.length - 1) return <>
            {text}
            {renderFootnoteLink(inlineLinks[i])}
        </>
        else return text
    })
}

const renderFootnoteLink = (footnoteLink, id) => {
    return <>
        <a
            id={id}
            className={footnoteLink.inline ? "getting-started-inline-link" : ""}
            href={footnoteLink.link}
            target="_blank"
            rel="noopener noreferrer">
            {footnoteLink.label}
        </a>
    </>
}
const GettingStartedQuestionnaire = (props) => {
    const {
        component,
        setDialog,
        checkIfDocumentsAreDeleted,
    } = props

    const [loading, setLoading] = useState(false)
    const [tab, setTab] = useState(component ?? IMPLEMENTATION_TYPE_PRODUCTS.ACS)

    const certificationPackageImplementationTypeActionHelper = (implementationType) => {
        checkIfDocumentsAreDeleted(implementationType, tab)
        setDialog(false)
    }
    const certificationPackageImplementationTypeAction = checkIfDocumentsAreDeleted ? certificationPackageImplementationTypeActionHelper : null

    const loadRequirementData = (requirement) => {
        return !requirement ? <span className="getting-started-not-required">NOT REQUIRED</span>
            :
            <Row className="getting-started-remark">
                <span className="visa-blue font-weight-bold">REQUIRED</span>
                {requirement.footnote > 0 &&
                    <Tooltip
                        // @ts-ignore
                        getTooltipContainer={() => document.getElementById('getting-started-page-question-dialog').childNodes[0]}
                        overlay={renderFootnote(GETTING_STARTED_FOOTNOTES[requirement.footnote])}
                        placement="left" trigger={["hover", "focus"]}>
                        <Icon className="icon-vsts getting-started-required-icon" name="info" resolution="low" aria-label="info" />
                    </Tooltip>
                }
            </Row>
    }

    const handleACSTableData = (tableData, data) => {
        let newTableData = [...tableData]
        tableData[0].remark = loadRequirementData(data.requirementEmvCo)
        tableData[1].remark = loadRequirementData(data.requirementPci3dsCoreAoc)
        tableData[2].remark = loadRequirementData(data.requirementVisaAcsSecurityProgram)
        tableData[3].remark = loadRequirementData(data.requirementVisaSecureProductProviderAgreement)
        tableData[4].remark = loadRequirementData(data.requirementBid)
        tableData[5].remark = loadRequirementData(data.requirementVstsTestingFees)
        tableData[6].remark = loadRequirementData(data.requirementCompleteVstsTesting)
        return newTableData
    }

    const handle3DSTableData = (tableData, data) => {
        let newTableData = [...tableData]
        tableData[0].remark = loadRequirementData(data.requirementEmvCo)
        tableData[1].remark = loadRequirementData(data.requirementPci3dsAoc)
        tableData[2].remark = loadRequirementData(data.requirementVisaThirdPartyAgentProgram)
        tableData[3].remark = loadRequirementData(data.requirementVisaSecureProductProviderAgreement)
        tableData[4].remark = loadRequirementData(data.requirementBid)
        tableData[5].remark = loadRequirementData(data.requirementVstsTestingFees)
        tableData[6].remark = loadRequirementData(data.requirementCompleteVstsTesting)
        return newTableData
    }

    return (
        <>
            {loading && <MCSOverlayLoading />}
            <Row>
                <Col>
                    <Dialog
                        aria-labelledby="getting-started-dialog"
                        aria-describedby="getting-started-dialog"
                        open={true}
                        id="getting-started-page-question-dialog"
                    >
                        <DialogCardClose>
                            <ButtonGroup direction="right">
                                <ButtonIcon
                                    ariaLabel="close"
                                    iconType="light-tiny"
                                    onClick={() => setDialog(false)}
                                >
                                    <Icon name="close" resolution="tiny" />
                                </ButtonIcon>
                            </ButtonGroup>
                        </DialogCardClose>
                        <DialogCardHead>
                            <DialogCardHeadTitle className="getting-started-dialog-title">Identifying your implementation type(s)</DialogCardHeadTitle>
                        </DialogCardHead>
                        <Row className="getting-started-tabs">
                            <TabList className="getting-started-tablist" selectedTab={tab - 1}>
                                <Tab onClick={() => setTab(IMPLEMENTATION_TYPE_PRODUCTS.ACS)} className="getting-started-tab tab-header">
                                    <img className="getting-started-acs-logo" src={tab === IMPLEMENTATION_TYPE_PRODUCTS.ACS ? iconACS : iconACSGray} alt={"acs-logo"} />
                                    <Typography
                                        style={tab === IMPLEMENTATION_TYPE_PRODUCTS.ACS ? {} : { color: "#3e3e3e", fontWeight: "300" }}
                                        tag="h4"
                                        variant="subtitle--alt"
                                        className="getting-started-tab-text">ACS</Typography>
                                </Tab>
                                <Tab onClick={() => setTab(IMPLEMENTATION_TYPE_PRODUCTS["3DS"])} className="getting-started-tab tab-header">
                                    <img className="getting-started-3dss-logo" src={tab === IMPLEMENTATION_TYPE_PRODUCTS["3DS"] ? icon3DSS : icon3DSSGray} alt={"3dss-logo"} />
                                    <Typography
                                        style={tab === IMPLEMENTATION_TYPE_PRODUCTS["3DS"] ? {} : { color: "#3e3e3e", fontWeight: "300" }}
                                        tag="h4"
                                        variant="subtitle--alt"
                                        className="getting-started-tab-text">3DS SERVER</Typography>
                                </Tab>
                            </TabList>
                        </Row>

                        <Questionnaire
                            api={gettingStartedService.CheckImplementationType}
                            certificationPackageAction={certificationPackageImplementationTypeAction}
                            handleTableData={handleACSTableData}
                            isToggled={tab === IMPLEMENTATION_TYPE_PRODUCTS.ACS}
                            product={IMPLEMENTATION_TYPE_PRODUCTS.ACS}
                            setLoading={setLoading}
                            questionnaire={QUESTIONS_ANSWERS_ACS}
                            tableHeaders={TABLE_HEADERS_ACS}
                        />

                        <Questionnaire
                            api={gettingStartedService.CheckImplementationType}
                            certificationPackageAction={certificationPackageImplementationTypeAction}
                            handleTableData={handle3DSTableData}
                            isToggled={tab === IMPLEMENTATION_TYPE_PRODUCTS["3DS"]}
                            product={IMPLEMENTATION_TYPE_PRODUCTS["3DS"]}
                            setLoading={setLoading}
                            questionnaire={QUESTIONS_ANSWERS_3DS}
                            tableHeaders={TABLE_HEADERS_3DS}
                        />

                    </Dialog>
                </Col>
            </Row>
        </>
    )
}

export default GettingStartedQuestionnaire